import api from './axiosConfig';
import CustomEventDispatcher from './CustomEventDispatcher';

/**
 * Communicatie met de gedeelde PDF-parse-wachtrij.
 * Live updates komen binnen via de WebSocketService ('parseQueueUpdated').
 */
class PdfParseQueueService extends CustomEventDispatcher {
  constructor() {
    super();
  }

  async getQueue() {
    try {
      const response = await api.get('/api/pdf-parse-queue');
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      }
      throw error;
    }
  }

  async retry(id) {
    try {
      const response = await api.post(`/api/pdf-parse-queue/${id}/retry`);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      }
      throw error;
    }
  }

  async remove(id) {
    try {
      const response = await api.delete(`/api/pdf-parse-queue/${id}`);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      }
      throw error;
    }
  }

  async removeFinished() {
    try {
      const response = await api.delete('/api/pdf-parse-queue/finished');
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this._dispatchUnauthorized();
      }
      throw error;
    }
  }
}

export default PdfParseQueueService;
